import { FormikHelpers, Formik, Form } from "formik";
import _ from "lodash";
import { useSnackbar } from "notistack";
import * as yup from "yup";

import { Card, CardHeader, CardContent } from "@material-ui/core";

import { useTenant } from "src/components/LoggedInAdminProvider";
import FormikErrorBanner from "src/components/form/FormikErrorBanner";
import FormikTextField from "src/components/form/FormikTextField";
import SubmitButton from "src/components/form/SubmitButton";
import {
  tenantEditNumberRotationThreshold,
  tenantEditNumberRotationThresholdVariables
} from "src/graphql/generated/tenantEditNumberRotationThreshold";
import { EDIT_TENANT_NUMBER_ROTATION_THRESHOLD } from "src/graphql/tenant";
import useMutation from "src/util/useMutation";

import { numberAsStringField } from "./common";

type Values = { numberRotationThreshold: string };
export default function Basics(): JSX.Element {
  const tenant = useTenant()!;
  const snackbar = useSnackbar();

  const schema = yup.object().shape({
    numberRotationThreshold: yup.number().nullable().positive().integer()
  });

  const [updateTenantNumberRotationThreshold] = useMutation<
    tenantEditNumberRotationThreshold,
    tenantEditNumberRotationThresholdVariables
  >(EDIT_TENANT_NUMBER_ROTATION_THRESHOLD, {
    onErrorSnackbarMessage: `Failed to update organization settings.`
  });

  async function handleSubmit(values: Values, helpers: FormikHelpers<Values>) {
    const newRotationThreshold =
      (values.numberRotationThreshold &&
        _.parseInt(values.numberRotationThreshold)) ||
      null;
    const { errors, data } = await updateTenantNumberRotationThreshold({
      variables: { newRotationThreshold }
    });

    if (!errors) {
      snackbar.enqueueSnackbar("Organization updated.", { variant: "info" });
      helpers.resetForm({
        values: {
          numberRotationThreshold: numberAsStringField(
            data!.tenantEditNumberRotationThreshold.numberRotationThreshold
          )
        }
      });
    }
  }

  return (
    <>
      <Card>
        <CardHeader title="Number Rotation Threshold" />
        <CardContent>
          <Formik
            initialValues={{
              numberRotationThreshold: numberAsStringField(
                tenant.numberRotationThreshold
              )
            }}
            onSubmit={handleSubmit}
            validationSchema={schema}
          >
            {({ isSubmitting, dirty }) => (
              <Form>
                <FormikErrorBanner />
                <FormikTextField
                  fullWidth
                  label="Number Rotation Threshold (leave blank to use system default)"
                  name="numberRotationThreshold"
                  disabled={isSubmitting}
                />
                <SubmitButton
                  type="submit"
                  disabled={!dirty}
                  isSubmitting={isSubmitting}
                  submitText="Update"
                  loadingText="Updating..."
                />
              </Form>
            )}
          </Formik>
        </CardContent>
      </Card>
    </>
  );
}
